// src/api/services/phoneVerificationService.ts
import api from "../axios";

export interface PhoneStatusDto {
  /** E.164, or null when the user has no number on file. */
  phoneNumber: string | null;
  verified: boolean;
  verifiedAt: string | null;
}

export interface SendCodeResultDto {
  /** False when the number was already verified — no code was sent. */
  codeSent: boolean;
  phoneNumber: string;
  verified: boolean;
}

export interface VerifyCodeResultDto {
  verified: boolean;
  phoneNumber: string;
}

/** Whether the signed-in user's current number is already verified. */
export function getPhoneStatus() {
  return api.get<PhoneStatusDto>("/phone-verification/status");
}

/**
 * Send an SMS code. Safe to call unconditionally — the API no-ops with
 * `codeSent: false` if the number is already verified for this user.
 */
export function sendPhoneCode(phoneNumber: string) {
  return api.post<SendCodeResultDto>("/phone-verification/send", {
    phoneNumber,
  });
}

/** On success the API marks the number verified and writes it to user.phone. */
export function verifyPhoneCode(phoneNumber: string, code: string) {
  return api.post<VerifyCodeResultDto>("/phone-verification/verify", {
    phoneNumber,
    code,
  });
}
